import { useTradingSettings } from '@src/providers/AppConfigProvider';
import { FormControlSizes, MixpanelEvent, MixpanelEventProperty, Toggle, useMixpanel } from '@talos/kyoko';
import { useCallback } from 'react';

export type MobileCompactCardType = 'Order' | 'Trade' | 'Transfer' | 'Position' | 'Balance' | 'Credit';

interface MobileCompactCardsToggleProps {
  type: MobileCompactCardType;
}

export function MobileCompactCardsToggle({ type }: MobileCompactCardsToggleProps) {
  const mixpanel = useMixpanel();
  const { compactMobileCards, setCompactMobileCards } = useTradingSettings();

  const handleCompactCardsChange = useCallback(
    (value: boolean) => {
      mixpanel.track(MixpanelEvent.ToggleCompactMobileCards, {
        [MixpanelEventProperty.Type]: type,
        [MixpanelEventProperty.Enabled]: value,
      });
      setCompactMobileCards(value);
    },
    [mixpanel, setCompactMobileCards, type]
  );

  return (
    <Toggle
      label="Compact Cards"
      size={FormControlSizes.Default}
      checked={compactMobileCards}
      onChange={handleCompactCardsChange}
      fullWidth
    />
  );
}
